/**
 * Handle all the data needed for the frontend ( live ) to work
 * @creator Stefano
 * @date 26-6-2018
 */
import EventEmitter from "events";
export default class DataCollector extends EventEmitter {
    constructor() {
        super();

        this.PENDING = "pending";
        this.READY = "ready";
        this.OK = "ok";
        this.ERROR = "error";
        /**
         * @property _issues
         * @type {Object}
         */
        this._issues = null;

        /**
         * @property _error
         * @type {Object}
         */
        this._error = null;

        this.init();
    }
    init() {
        Object.defineProperty(this, "issues", {
            get: function () {
                return this._issues;
            },
            set: function (value) {
                this._setIssues(value);
            },
        });
    }

    _ajaxCall(url, dataType, type, body) {
        var scope = this;

        $.ajax({
            type: type,
            url: url,
            dataType: dataType,
            data: body,
            success: function (data) {
                scope._storeDataLegacyJson(data);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                if (XMLHttpRequest.status == 0) {
                    alert("Unable to reach " + window.data_domain + "\n Please check your firewall / proxy settings");
                } else {
                    alert("Status: " + textStatus + " \n Error: " + XMLHttpRequest.status + " - " + errorThrown);
                }
            },
        });
    }

    getIssueIsSecure(issue_id) {
        try {
            for (var i in this._issues) {
                if (this._issues[i].issue_id == issue_id) {
                    return this._issues[i].security;
                }
            }
            return false;
        } catch (e) {
            console.warn(e);
        }
    }

    /**
     * retrieve the issues/spreads inlined by the server (window.issues, built from overview.json)
     *
     */
    getIssuesSpreads() {
        this._pendingList = ["issues"];
        this.on(this.PENDING, (name) => {
            this.fireDataReady(name);
        });

        //if we have legacy magazine start retrieving data
        if (self.legacy) {
            this.getLegacyJSON();
        }
        this._storeDataJson({ issues: window.issues || {} });
    }

    fireDataReady(name) {
        if (this._pendingList.indexOf(name) >= 0) {
            this._pendingList.splice(this._pendingList.indexOf(name), 1);
        }

        if (this._pendingList.length == 0) {
            this.removeAllListeners(this.PENDING);
            this.emit(this.READY);
        }
    }

    getLegacyJSON() {
        this._pendingList.push("legacy");
        this._ajaxCall(
            window.data_domain + "/" + window.client_id + "/legacy/issues.json?t=" + window.cache_timestamp,
            "json",
            "GET",
        );
    }

    /**
     * Store the data that was just fetched from the server.
     *
     * @method _storeData
     * @param response
     * @private
     */
    _storeDataJson(response) {
        this.issues = response.issues;

        //Dispatch event en listen in de loader.
        this.emit(this.PENDING, "issues");
    }

    /**
     * Store the data that was just fetched from the server.
     *
     * @method _storeData
     * @param response
     * @private
     */
    _storeDataLegacyJson(response) {
        this.legacy_issues = response.issues;
        //Dispatch event en listen in de loader.
        this.emit(this.PENDING, "legacy");
    }

    _setIssues(data) {
        this._issues = data;
    }
}
